import { Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { DropDownButton } from "lib/@components/drop-down-button"
import { AssetInfo } from "routes/regime/plugins/zero-u-wizard/asset-info"

export function CountEntry({ count = 0, showOne, ...props }) {
    return (showOne && count > 0) || count > 1 ? (
        <DropDownButton
            data-cy="task-count"
            Component={Typography}
            variant="caption"
            content={<AssetInfo $lazy {...props} />}
            sx={{ fontWeight: "bold", whiteSpace: "nowrap", pt: 0.2 }}
            keepMounted={false}
        >
            {count} {"asset".pluralize(count)}
            <Iconify icon="mdi:arrow-drop-down" />
        </DropDownButton>
    ) : null
}
